function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M6.54.8a3.28 3.28 0 100 6.55 3.28 3.28 0 000-6.55zM5.37 2.91A1.65 1.65 0 117.7 5.24a1.65 1.65 0 01-2.33-2.33zm8.55.35a.82.82 0 00-.81.82v1.64h-1.65a.82.82 0 000 1.63h1.65V9a.82.82 0 101.63 0V7.35h1.64a.82.82 0 000-1.63h-1.64V4.08a.82.82 0 00-.82-.82zM5.13 8.18C2.85 8.18.8 9.83.8 12.08v1.02a.82.82 0 001.63 0v-1.02c0-1.15 1.1-2.26 2.7-2.26h2.81c1.6 0 2.7 1.1 2.7 2.26v1.02a.82.82 0 001.64 0v-1.02c0-2.25-2.05-3.9-4.34-3.9h-2.8z",
  clipRule: "evenodd"
});

function SvgAddUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 14,
    fill: "#fff",
    viewBox: "0 0 18 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.f4b161c8.svg";
export { ForwardRef as ReactComponent };